import useBackend from '@/hooks/useBackend'

import config from '@/config'

const { setup, doGet } = useBackend()
setup('/', config.resourceBaseUrl)

export default function useResources() {
  function fetchContentByPath(path) {
    return doGet(path)
  }

  function fetchContentLibrary({ file, ...payload }) {
    return doGet(`content/sanitas-internet/content-library/${file}`, payload)
  }

  function fetchNotificationMessages({ serviceUri, ...payload }) {
    return doGet(serviceUri, payload, true)
  }

  return {
    fetchContentByPath,
    fetchContentLibrary,
    fetchNotificationMessages,
  }
}
